var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.143,
    height: 17.922,
    viewBox: "0 0 13.143 17.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Registered_Address",
    "data-name": "Registered Address",
    transform: "translate(-441.778 -185.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M448.35,203.18a.606.606,0,0,0,.466-.227c.251-.31,6.106-7.659,6.106-11.124a6.572,6.572,0,1,0-13.143,0c0,3.465,5.855,10.813,6.106,11.124a.606.606,0,0,0,.466.227Zm0-16.728a5.385,5.385,0,0,1,5.377,5.377c0,2.318-3.537,7.384-5.377,9.786-1.84-2.4-5.377-7.468-5.377-9.786A5.385,5.385,0,0,1,448.35,186.453Z",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M487.22,227.71a2.987,2.987,0,1,0-2.987,2.987A2.988,2.988,0,0,0,487.22,227.71Zm-4.779,0a1.792,1.792,0,1,1,1.792,1.792,1.79,1.79,0,0,1-1.792-1.792Z",
    transform: "translate(-35.883 -35.88)",
    fill: "#ff7200"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.53b7bcce93ff1e0be5e9877f7caf9499.svg";
export { ForwardRef as ReactComponent };